import  restaurant from '../Reducers/data/restaurant.json'

const Documenu = require('documenu')
Documenu.configure('2819d56d5a2933d849fe489b804c8ebd')

export const getRestaurantMenu = (dispatch, restaurantId, pageNumber) =>{
    const params = {
        page: pageNumber
    }

    dispatch({
        type: "get-restaurant",
        restaurant: restaurant,
    })
}

export default getRestaurantMenu;